<template>
    <modal-page
        :heading="hasSubmitted ? 'Thank you for registering!' : 'Sign up for a new account'"
        class="modal-page">
        <template v-if="hasSubmitted">
            <p>Once your account is approved by Vivid Seats you will be able to start transacting on the site.</p>
        </template>
        <template v-else>
            <form
                class="form grid"
                @submit.prevent="submit"
                novalidate>
                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <label
                            class="reader-only"
                            for="RegisterFirstName">First Name</label>
                        <input
                            autocomplete="given-name"
                            id="RegisterFirstName"
                            name="RegisterFirstName"
                            placeholder="First Name"
                            type="text"
                            v-model.trim="firstName"
                            v-validate.disable="'required'"
                            :class="{ 'input--invalid': errors.has('RegisterFirstName') }">
                        <span
                            class="error-message"
                            v-if="errors.has('RegisterFirstName')">{{ errors.first('RegisterFirstName') }}</span>
                    </div>
                </div>

                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <label
                            class="reader-only"
                            for="RegisterLastName">Last Name</label>
                        <input
                            autocomplete="family-name"
                            id="RegisterLastName"
                            name="RegisterLastName"
                            placeholder="Last Name"
                            type="text"
                            v-model.trim="lastName"
                            v-validate.disable="'required'"
                            :class="{ 'input--invalid': errors.has('RegisterLastName') }">
                        <span
                            class="error-message"
                            v-if="errors.has('RegisterLastName')">{{ errors.first('RegisterLastName') }}</span>
                    </div>
                </div>

                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <label
                            class="reader-only"
                            for="RegisterEmail">Email Address</label>
                        <input
                            autocomplete="email"
                            id="RegisterEmail"
                            name="RegisterEmail"
                            placeholder="Email Address"
                            type="email"
                            v-model.trim="email"
                            v-validate.disable="'required|email|whitelisted-domain'"
                            :class="{ 'input--invalid': errors.has('RegisterEmail') }">
                        <span
                            class="error-message"
                            v-if="errors.has('RegisterEmail')">{{ errors.first('RegisterEmail') }}</span>
                    </div>
                </div>

                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <label
                            class="reader-only"
                            for="RegisterPassword">Password (min 8 characters)</label>
                        <input
                            autocomplete="new-password"
                            id="RegisterPassword"
                            name="RegisterPassword"
                            placeholder="Password"
                            ref="RegisterPassword"
                            type="password"
                            v-model.trim="password"
                            v-validate.disable="'required|min:8'"
                            :class="{ 'input--invalid': errors.has('RegisterPassword') }">
                        <span
                            class="error-message"
                            v-if="errors.has('RegisterPassword')">{{ errors.first('RegisterPassword') }}</span>
                    </div>
                </div>

                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <label
                            class="reader-only"
                            for="RegisterConfirmPassword">Confirm Password</label>
                        <input
                            autocomplete="new-password"
                            id="RegisterConfirmPassword"
                            name="RegisterConfirmPassword"
                            placeholder="Confirm Password"
                            type="password"
                            v-validate.disable="'required|confirmed:RegisterPassword'"
                            :class="{ 'input--invalid': errors.has('RegisterConfirmPassword') }">
                        <span
                            class="error-message"
                            v-if="errors.has('RegisterConfirmPassword')">{{ errors.first('RegisterConfirmPassword') }}</span>
                    </div>
                </div>

                <div class="grid__row">
                    <div class="grid__col grid__col--100">
                        <button
                            class="submit"
                            type="submit"
                            :disabled="isSaving">Sign Up</button>
                    </div>
                </div>

            </form>
            <p class="modal-page__login">Already have an account? <router-link :to="{ name: 'login' }">Sign In</router-link></p>
        </template>
    </modal-page>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import modalPage from '../components/ModalPage.vue'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Sign-up at ${this.$config.partnerName}`
    },
    components: {
        modalPage
    },
    created () {
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
    },
    data () {
        return {
            email: '',
            firstName: '',
            hasSubmitted: false,
            isSaving: false,
            lastName: '',
            password: ''
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        submit () {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) { return }

                    this.isSaving = true

                    return this.$marketplace
                        .signup({
                            email_address: this.email,
                            first_name: this.firstName,
                            last_name: this.lastName,
                            password: this.password,
                            return_url: window.location.origin
                        })
                        .then(() => { this.hasSubmitted = true })
                        .catch(err => this.catchAndNotify(err))
                        .finally(() => { this.isSaving = false })
                })
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.form {
    margin-top: 30px;
}

.grid {
    text-align: left;
}

.modal-page {
    text-align: center;

    & .modal-page__login {
        margin: 40px 0 0;
    }
}
</style>
